import {
  GameType,
  TrackingPageGameBlock,
} from "@redotech/redo-model/order-tracking/tracking-page-definition";
import { useEffect } from "react";
import { GameState } from "../game";
import { GameControls } from "../game-controls";

export function useLevelUpdates(
  blockProps: TrackingPageGameBlock,
  gameControls: GameControls | null,
  gameState: GameState,
) {
  // Extract complex expressions for dependency array
  const isCleanupCrew = blockProps.gameType === GameType.CLEANUP_CREW;
  const selectedLevel = isCleanupCrew
    ? blockProps.gameSettings?.selectedLevel
    : null;
  const useRandomLevel = isCleanupCrew
    ? blockProps.gameSettings?.useRandomLevel
    : null;

  useEffect(() => {
    if (
      blockProps.gameType === GameType.CLEANUP_CREW &&
      gameControls?.updateLevel &&
      gameState === GameState.Gameplay &&
      blockProps.gameSettings
    ) {
      const actualSelectedLevel = blockProps.gameSettings.selectedLevel || 0;
      const actualUseRandomLevel =
        blockProps.gameSettings.useRandomLevel || false;

      gameControls.updateLevel(actualSelectedLevel, actualUseRandomLevel);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedLevel, useRandomLevel]);
}
